// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3WDog","signatureButtonsRight":"ModalSign_signatureButtonsRight__WsmcM"};